import { FC, useEffect } from 'react';
import { observer } from 'mobx-react';

import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Mask } from '@servicetitan/design-system';

import { ExternalOptIn } from './modules/widget/api/widget.api';
import { AuthStore } from './modules/widget/stores/auth.store';
import { ExceptionStore } from './modules/widget/stores/exception.store';
import { WidgetStore } from './modules/widget/stores/widget.store';
import { Widget } from './modules/widget/components/widget/widget';
import { USE_WINDOW_TOKEN } from './modules/widget/utils/tokens';
import { logger, USE_LOGGER_TOKEN } from './modules/widget/utils/logger';

import './app.css';
import './design-system.css';

export const App: FC = provide({
    singletons: [
        { provide: USE_WINDOW_TOKEN, useValue: window },
        { provide: USE_LOGGER_TOKEN, useValue: logger },
        AuthStore,
        ExceptionStore,
        WidgetStore,
        ExternalOptIn,
    ],
})(
    observer(() => {
        const [{ isAuthenticated, init }] = useDependencies(AuthStore);

        useEffect(() => {
            init(window, window.location.search);
        }, [init]);

        return (
            <Mask active={!isAuthenticated}>
                <Widget />
            </Mask>
        );
    })
);
